import React from 'react';
import { iconMap } from './iconMap';

/**
 * Recursively transforms menu data to replace string icon references with React components
 * @param menuData - The menu data array to transform
 * @returns Transformed menu data with React icon components
 */
export const transformMenuData = (menuData: any[]): any[] => {
  return menuData.map((item: any) => {
    const newItem = { ...item };

    // Transform icon if it's a string reference
    if (item.icon && typeof item.icon === 'string' && iconMap[item.icon]) {
      newItem.icon = React.createElement(iconMap[item.icon]);
    }

    // Recursively transform nested routes
    if (item.routes && Array.isArray(item.routes)) {
      newItem.routes = transformMenuData(item.routes);
    }

    // Also handle children property (alternative to routes)
    if (item.children && Array.isArray(item.children)) {
      newItem.children = transformMenuData(item.children);
    }

    return newItem;
  });
};
